/**
 * @function spinner Spinner template, shared between different templates
 * @return {string}
 */

const LoadersTypes = ['xx-small', 'x-small', 'small', 'medium', 'large', 'x-large' ];

const spinnerLinear = ({ type , text }) => {

    const typeWithoutStatus = ( type !== undefined && ( type.endsWith('--success') || type.endsWith('--error') )) ? type.split('--')[0] : type;
    const spinnerType = ( typeWithoutStatus !== undefined && LoadersTypes.includes(typeWithoutStatus) ) ? typeWithoutStatus : 'small';

    return `<div class="spinner spinner--linear spinner--${spinnerType}">
		<span class="fill spinner__fill">
			<!--<span> node for percentuage ? </span>-->
		</span>
		<span class="text spinner__text">
			${text !== undefined && text !== "" ?  text : ``}
		</span>
	</div>`;
};

/**
 * @function check icon template, shared between different templates
 * @return {string}
 */

const checkIconStatic = ({ type , text }) => {

    const typeWithoutStatus = ( type !== undefined && ( type.endsWith('--success') || type.endsWith('--error') )) ? type.split('--')[0] : type;
    const checkIconType = ( typeWithoutStatus !== undefined && LoadersTypes.includes(typeWithoutStatus) ) ? typeWithoutStatus : 'small';

    return `<div class="checkIcon checkIcon--static checkIcon--${checkIconType} ">
		<span class="fill checkIcon__fill">
		    <i class="lsicon ">
		        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="13" viewBox="0 0 21 13" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="CCC" d="M7.97739787,16.0063419 C7.56358838,16.0063419 7.14934868,15.8710527 6.83367374,15.6002693 L1.11371466,10.6974472 C0.481886781,10.1558805 0.481886781,9.27797528 1.11371466,8.73640853 C1.74554253,8.19484178 2.76976525,8.19484178 3.40159313,8.73640853 L7.97739787,12.6585269 L18.2731617,3.83375034 C18.9049896,3.29234748 19.9294513,3.29218359 20.560849,3.83375034 C21.1928681,4.37531709 21.1928681,5.25342714 20.560849,5.79478903 L9.12136101,15.6002693 C8.80544707,15.8708888 8.39139857,16.0063419 7.97739787,16.0063419 Z"/></defs><g fill="none" fill-rule="evenodd" transform="translate(0 -3)"><use fill="#000000" fill-rule="nonzero" xlink:href="#CCC"/></g></svg>
		    </i>
		</span>
		<span class="text checkIcon__text">
			${text !== undefined && text !== "" ?  text : ``}
		</span>
	</div>`;
};

/**
 * @function error icon template, shared between different templates
 * @return {string}
 */

const errorIconStatic = ({ type , text }) => {

    const typeWithoutStatus = ( type !== undefined && ( type.endsWith('--success') || type.endsWith('--error') )) ? type.split('--')[0] : type;
    const errorIconType = ( typeWithoutStatus !== undefined && LoadersTypes.includes(typeWithoutStatus) ) ? typeWithoutStatus : 'small';

    return `<div class="errorIcon errorIcon--static errorIcon--${errorIconType}">
		<span class="fill errorIcon__fill">
		    <i class="lsicon ">
		        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="#F05439" d="M12.3478915,9.97647505 L19.4618599,2.86250664 C20.1167093,2.20765731 20.1167093,1.1459395 19.4618599,0.491183844 C18.8070106,-0.163665492 17.7453865,-0.163665492 17.0905371,0.491183844 L9.97647505,7.60524593 L2.86241296,0.49109016 C2.20756363,-0.163759176 1.1459395,-0.163759176 0.49109016,0.49109016 C-0.163665492,1.1459395 -0.163665492,2.20765731 0.49109016,2.86241296 L7.60515225,9.97638136 L0.49109016,17.0904435 C-0.163665492,17.7452928 -0.163665492,18.8070106 0.49109016,19.4617663 C1.1459395,20.1166156 2.20756363,20.1166156 2.86241296,19.4617663 L9.97647505,12.3477042 L17.0905371,19.4617663 C17.7452928,20.1166156 18.8070106,20.1166156 19.4618599,19.4617663 C20.1167093,18.8069169 20.1167093,17.7452928 19.4618599,17.0904435 L12.3478915,9.97647505 Z"/></svg>
		    </i>
		</span>
		<span class="text errorIcon__text">
			${text !== undefined && text !== "" ?  text : ``}
		</span>
	</div>`;
};

/**
 * @class HtmlTemplates
 * @classdesc Utility to create simple HTML nodes, with small configurations
 * @type {object}
 */
export const HtmlTemplates = {

    /**
     * @method loader with overlay & text Create the loading spinner
     * @return {string}
     */
	blockLoader({ blockType , type , text  } ) {

	    let template = () => {};

        if(blockType.endsWith('--success') || blockType.endsWith('--loaded') ) {
            template = checkIconStatic;
        }
        else if(blockType.endsWith('--error') ) {
            template = errorIconStatic;
        }
        else {
            template = spinnerLinear;
        }
        return `<div data-component-name="loader">
				<div class="layer layer--${blockType}" >
					<div class="layer__inner layer__inner--${blockType}">
						${template({ type })}
						<div class="text">
							${(typeof text !== undefined && text !== '') ? text : ''}
						</div>
					</div>
				</div>
			</div>`;
	},


    /**
     * @method loader Create the loading spinner
     * @return {string}
     */
    loader( { loaderType , loaderText } ){
        let type = ( loaderType !== undefined ) ? loaderType : 'small';
        let text = ( loaderText !== undefined ) ? loaderText : '';
        let blockType = type;

        if(blockType === 'dialog' || blockType.startsWith('dialog--') || blockType === 'inline-dialog' || blockType.startsWith('inline-dialog--') || blockType === 'static-dialog' || blockType.startsWith('static-dialog--') || blockType === 'fullpage') {

            type = ( blockType === 'fullpage') ? 'large' : 'x-small';

            return this.blockLoader({ blockType, type , text });
        }
        else if(blockType !== 'dialog' && blockType.endsWith('--success')) {
            return `<div data-component-name="loader">${checkIconStatic({ type , text })}</div>`;
        }
        else if(blockType !== 'dialog' && blockType.endsWith('--error')) {
            return `<div data-component-name="loader">${errorIconStatic({ type , text })}</div>`;
        }
        else {
            return `<div data-component-name="loader">${spinnerLinear({ type , text })}</div>`;
        }
    },

    /**
     * @method incomingCall callBar buttonsBar
     * @return {string}
     */
    manageCallBarModal({ id = 'wildixButtons'  }) {
        let modifier = `modal modal--manageCallBar hidden`;

        return `<div data-component-name="modal" class="${modifier}" id="${id}" >
                <div class="modal__content">
                     <span class="modal__content--callType" id="CallType"></span>
                     <span class="modal__content--phoneNumber" id="CallNumber"></span>
                     <button data-component-name="button" class="modal__content--button btn btn--alert" id="HangupCal_l" >${ EFLANG.get('common_riaggancia_chiamata') }</button>
                     <button data-component-name="button" class="modal__content--button btn VisibleIfAnswered" id="TransferCall" >
                        <span class="icon"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path fill="#000000" fill-rule="nonzero" d="M14.5857864,6 L14.2928932,5.70710678 C13.9023689,5.31658249 13.9023689,4.68341751 14.2928932,4.29289322 C14.6834175,3.90236893 15.3165825,3.90236893 15.7071068,4.29289322 L17.7071068,6.29289322 C18.0976311,6.68341751 18.0976311,7.31658249 17.7071068,7.70710678 L15.7071068,9.70710678 C15.3165825,10.0976311 14.6834175,10.0976311 14.2928932,9.70710678 C13.9023689,9.31658249 13.9023689,8.68341751 14.2928932,8.29289322 L14.5857864,8 L13,8 C12.4477153,8 12,7.55228475 12,7 C12,6.44771525 12.4477153,6 13,6 L14.5857864,6 Z M18.2928932,5.70710678 C17.9023689,5.31658249 17.9023689,4.68341751 18.2928932,4.29289322 C18.6834175,3.90236893 19.3165825,3.90236893 19.7071068,4.29289322 L21.7071068,6.29289322 C22.0976311,6.68341751 22.0976311,7.31658249 21.7071068,7.70710678 L19.7071068,9.70710678 C19.3165825,10.0976311 18.6834175,10.0976311 18.2928932,9.70710678 C17.9023689,9.31658249 17.9023689,8.68341751 18.2928932,8.29289322 L19.5857864,7 L18.2928932,5.70710678 Z"/><path fill="#000000" d="M11.6789336,16.9442033 C11.6789336,16.9442033 13.3112417,16.5435546 13.7336199,16.4559254 C14.1551579,16.3673058 14.5483486,16.4272095 14.7383179,16.633837 C15.0258666,16.9471455 17.3955623,19.7346985 17.5926719,19.9778518 C17.7896823,20.2213514 17.7669613,20.7488766 17.289322,21.1350878 C16.8133149,21.5221417 14.7075708,22.9870327 14.0533968,22.7773402 C13.3984819,22.5663109 10.6672404,21.7179309 6.97087331,15.0474064 C3.27480161,8.37846568 4.00183175,5.61167811 4.17016781,4.94489589 C4.33850386,4.27811367 6.6968748,3.26792271 7.27721286,3.06856124 C7.8581442,2.86974465 8.3158606,3.13853151 8.41950325,3.42533942 C8.53726047,3.7517973 9.62566412,7.22278703 9.74157401,7.6184215 C9.8212332,7.88823361 9.65857756,8.25420923 9.35994347,8.56507875 C9.06205036,8.87728505 7.85738882,10.048903 7.85738882,10.048903 C7.85738882,10.048903 8.14648741,11.176271 9.51147743,13.6382528 C10.8767144,16.1006801 11.6789336,16.9442033 11.6789336,16.9442033 Z"/></g></svg></span>
                        <span class="label">${ EFLANG.get('common_trasferisci_chiamata') }</span>
                     </button>
                     <div data-component-name="input" id="TransferToCall" class="input modal__content--input">
                        <input type="text" value="" id="TransferToCallInput" placeholder="${ EFLANG.get('common_trasferisci_chiamata') }" class="input__text" >
                     </div>
                     <button data-component-name="button" class="modal__content--button btn VisibleIfAnswered" id="HoldCall" >
                        <span class="icon"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path fill="#000000" fill-rule="nonzero" d="M15 10.5C14.7238576 10.5 14.5 10.2761424 14.5 10L14.5 4C14.5 3.72385763 14.7238576 3.5 15 3.5L16 3.5C16.2761424 3.5 16.5 3.72385763 16.5 4L16.5 10C16.5 10.2761424 16.2761424 10.5 16 10.5L15 10.5zM19 10.5C18.7238576 10.5 18.5 10.2761424 18.5 10L18.5 4C18.5 3.72385763 18.7238576 3.5 19 3.5L20 3.5C20.2761424 3.5 20.5 3.72385763 20.5 4L20.5 10C20.5 10.2761424 20.2761424 10.5 20 10.5L19 10.5z"/><path fill="#000000" d="M11.6789336,16.9442033 C11.6789336,16.9442033 13.3112417,16.5435546 13.7336199,16.4559254 C14.1551579,16.3673058 14.5483486,16.4272095 14.7383179,16.633837 C15.0258666,16.9471455 17.3955623,19.7346985 17.5926719,19.9778518 C17.7896823,20.2213514 17.7669613,20.7488766 17.289322,21.1350878 C16.8133149,21.5221417 14.7075708,22.9870327 14.0533968,22.7773402 C13.3984819,22.5663109 10.6672404,21.7179309 6.97087331,15.0474064 C3.27480161,8.37846568 4.00183175,5.61167811 4.17016781,4.94489589 C4.33850386,4.27811367 6.6968748,3.26792271 7.27721286,3.06856124 C7.8581442,2.86974465 8.3158606,3.13853151 8.41950325,3.42533942 C8.53726047,3.7517973 9.62566412,7.22278703 9.74157401,7.6184215 C9.8212332,7.88823361 9.65857756,8.25420923 9.35994347,8.56507875 C9.06205036,8.87728505 7.85738882,10.048903 7.85738882,10.048903 C7.85738882,10.048903 8.14648741,11.176271 9.51147743,13.6382528 C10.8767144,16.1006801 11.6789336,16.9442033 11.6789336,16.9442033 Z"/></g></svg></span>
                        <span class="label">${ EFLANG.get('common_attesa_chiamata') }</span>
                     </button>
                     <span class="modal__content--callDuration" id="CallDuration">00:00</span>
                     <button data-component-name="button" class="modal__content--button btn btn--primary" id="AnswerCall" >${ EFLANG.get('common_rispondi_chiamata') }</button>
                </div>
			</div>`;
    },

    /**
     * @method base modal layer
     * @return {string}
     */
    modal({ title = '', content = '' , type = '' , id = '', buttons = [] , showFooter = true }) {
        let modifier = ( type && type !== '' && type !== 'modal') ? `modal modal--${type}` : 'modal',
            preCustomContent = '',
            postCustomContent = '',
            footerBtns = '';

        if(showFooter !== true) {
            modifier += ' modal--noFooter'
        }

        if( typeof buttons === "object") {
					
            for( let button of buttons) {
                let buttonId = (button.id && document.querySelector(`#${button.id}`) === null) ? button.id : '',
                    buttonClassName = 'modal__footer--button' + ((button.className && button.className !== 'modal__footer--button') ? ' ' + button.className : '');
						
                footerBtns += `<button data-component-name="button" class="${buttonClassName}" id="${buttonId}" >${button.value}</button>`;
            }
        }

        if ( type && type === 'incomingCall') {
            preCustomContent = '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="20" viewBox="0 0 15 20"><path fill="#000000" fill-rule="evenodd" d="M6.79504532,11.7344246 C6.79504532,11.7344246 7.63009863,13.1930661 7.8307564,13.5749282 C8.03213466,13.9557097 8.08292953,14.3501805 7.93666912,14.589745 C7.71475676,14.952514 5.68836551,17.9987655 5.50896234,18.2552616 C5.32919892,18.5117577 4.81584647,18.6353225 4.31294119,18.2826404 C3.80967567,17.9317595 1.82111039,16.311367 1.84236498,15.6247356 C1.86470031,14.9370234 1.92738335,12.0777403 7.32064618,6.68591847 C12.712468,1.29481713 15.5724716,1.23105335 16.2598235,1.20907827 C16.9471754,1.18710318 18.5682884,3.17566846 18.9198898,3.67857374 C19.271131,4.18219951 19.1389202,4.69627245 18.8917905,4.87495513 C18.6104374,5.07813463 15.5739126,7.0811098 15.2255534,7.30158117 C14.9881504,7.4525248 14.5915181,7.39704671 14.2103764,7.19566845 C13.828154,6.99537093 12.3698728,6.16031761 12.3698728,6.16031761 C12.3698728,6.16031761 11.3658635,6.74896176 9.37549696,8.73968852 C7.3847702,10.7307755 6.79504532,11.7344246 6.79504532,11.7344246 Z" transform="rotate(-74 8.988 11.845)"/></svg>';
        }

        if ( type && type === 'manageCallBar') {

            return this.manageCallBarModal({ id });
        }
        else {

            let baseModalTemplate = `<div data-component-name="modal" class="${modifier}" id="${id}">
                <div class="modal__header" >
                    <span class="modal__header--title" >${( title && title !== '') ? title : ''}</span>
                    <button type="button" role="button" title="Close" class="modal__header--closeButton">
                        <span class="icon"></span>
                        <span class="label"></span>
                    </button>
                </div>
                <div class="modal__content">
                    ${ preCustomContent }
                    ${( content && content !== '') ? content : ''}
                    ${ postCustomContent }
                </div>`;

            if(showFooter === true) {
                baseModalTemplate +=`<div class="modal__footer">${ footerBtns }</div>`;
            }

            baseModalTemplate += '</div>';

            return baseModalTemplate;
        }
    },

    /**
     * @method base autocomplete template list
     * @return {string}
     */
    autocomplete({ key = '' , value = '' , type = '' , id = '' }) {
        let modifier = ( type && type !== '' && type !== 'autocomplete') ? `autocomplete autocomplete--hidden autocomplete--${type}` : 'autocomplete autocomplete--hidden';

        return `<div data-component-name="autocomplete" class="${modifier}" id="${id}">
            <ul class="autocomplete__list">
            </ul>
        </div>`;
    }
};


// WEBPACK FOOTER //
// ./cpanel/js/utils/html-templates.js